import { combineReducers } from '@reduxjs/toolkit';
import data from './data-slice';
import state from './state-slice';

const navManagerReducer = combineReducers({ data, state });
export default navManagerReducer;
